(function () {
  var AG = window.AG || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    try { return (cents / 100).toLocaleString(document.documentElement.lang || 'pl', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN' }); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  var fill = function (s, vars) { Object.keys(vars || {}).forEach(function (k) { s = s.split('{{ ' + k + ' }}').join(vars[k]).split('{' + k + '}').join(vars[k]); }); return s; };

  /* ---------- Menu mobilne, wyszukiwarka, język ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('#menuOpen')) { document.body.classList.add('menu-open'); return; }
    if (t.closest('#menuClose') || t.closest('.drawer-bg')) document.body.classList.remove('menu-open');
    var lb = t.closest('.lang-btn');
    if (lb) { lb.parentElement.classList.toggle('is-open'); return; }
    if (!t.closest('.lang')) $$('.lang').forEach(function (x) { x.classList.remove('is-open'); });
    if (t.closest('#searchOpen')) { openSearch(); return; }
    if (t.closest('[data-close-search]')) closeSearch();
    if (t.closest('[data-close-notify]')) hideNotify();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); hideNotify(); document.body.classList.remove('menu-open'); }
  });

  function openSearch() {
    var s = $('#search');
    if (!s) return;
    s.innerHTML = '<div class="box"><form class="field" action="' + (window.location.pathname.replace(/\/[a-z-]*$/, '') + '/search') + '" method="get">' +
      '<input id="q" name="q" placeholder="' + (AG.strings.searchPlaceholder || '') + '" autocomplete="off">' +
      '<button class="icon-btn" type="button" data-close-search aria-label="close">✕</button></form><div class="res" id="res"></div></div>';
    s.classList.add('is-open');
    var q = $('#q'); setTimeout(function () { q.focus(); }, 50);
    var timer;
    q.addEventListener('input', function () {
      clearTimeout(timer);
      var v = q.value.trim();
      if (v.length < 2) { $('#res').innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources.results.products || []);
            $('#res').innerHTML = items.length ? items.map(function (p) {
              return '<a href="' + p.url + '">' + (p.image ? '<div class="art cover"><img src="' + p.image + '" alt=""></div>' : '<span></span>') +
                '<span>' + p.title + '</span><b>' + p.price + '</b></a>';
            }).join('') : '<p class="muted">' + (AG.strings.searchEmpty || '') + '</p>';
          });
      }, 220);
    });
  }
  function closeSearch() { var s = $('#search'); if (s) s.classList.remove('is-open'); }

  /* ---------- Galeria ---------- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (th) {
      var wrap = th.closest('[data-product-gallery]');
      var main = wrap.querySelector('.gal-main img');
      if (main) main.src = th.dataset.src;
      $$('[data-thumb]', wrap).forEach(function (b) { b.classList.toggle('is-on', b === th); });
      return;
    }
    var arrow = e.target.closest('[data-thumbs-next], [data-thumbs-prev]');
    if (arrow) {
      var strip = arrow.closest('.gal-strip').querySelector('[data-thumbs]');
      strip.scrollBy({ left: strip.clientWidth * 0.8 * (arrow.hasAttribute('data-thumbs-next') ? 1 : -1), behavior: 'smooth' });
    }
  });
  function initStrip(strip) {
    var wrap = strip.closest('.gal-strip');
    if (!wrap || strip.dataset.ready) return;
    strip.dataset.ready = '1';
    var prev = wrap.querySelector('[data-thumbs-prev]'), next = wrap.querySelector('[data-thumbs-next]');
    var upd = function () {
      var more = strip.scrollWidth - strip.clientWidth;
      if (prev) prev.hidden = more < 8 || strip.scrollLeft < 8;
      if (next) next.hidden = more < 8 || strip.scrollLeft >= more - 8;
    };
    strip.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    if (window.ResizeObserver) new ResizeObserver(upd).observe(strip);
    $$('img', strip).forEach(function (img) {
      if (!img.complete) img.addEventListener('load', upd, { once: true });
    });
    setTimeout(upd, 60);
    setTimeout(upd, 400);
    requestAnimationFrame(upd);
  }
  $$('[data-thumbs]').forEach(initStrip);
  document.addEventListener('shopify:section:load', function () { $$('[data-thumbs]').forEach(initStrip); });

  /* ---------- Akordeony ---------- */
  function initAcc(d) {
    if (d.dataset.ready) return;
    d.dataset.ready = '1';
    var s = d.querySelector('summary'), body = d.querySelector('.acc-body');
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.dataset.anim) return;
      d.dataset.anim = 1;
      var h;
      if (!d.open) {
        d.open = true; h = body.scrollHeight;
        body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.22,.8,.24,1)' })
          .onfinish = function () { delete d.dataset.anim; };
      } else {
        h = body.scrollHeight;
        body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'cubic-bezier(.22,.8,.24,1)' })
          .onfinish = function () { d.open = false; delete d.dataset.anim; };
      }
    });
  }
  $$('details.acc').forEach(initAcc);
  document.addEventListener('shopify:section:load', function () { $$('details.acc').forEach(initAcc); });

  /* ---------- Koszyk AJAX ---------- */
  function updateCount(count, bump) {
    var el = $('#cartCount');
    if (!el) return;
    el.textContent = count || '';
    el.classList.toggle('has', count > 0);
    if (bump) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  }
  function addToCart(id, btn, thenGoToCart) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = '<span class="spin"></span>'; btn.disabled = true; }
    return fetch(AG.addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        var item = (data && data.items && data.items.length) ? data.items[0] : data;
        return fetch(AG.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCount(cart.item_count, true);
          if (thenGoToCart) { window.location.href = AG.cartUrl; return; }
          if (!AG.showNotify) { return; }
          if (btn) {
            btn.classList.add('is-done');
            btn.innerHTML = AG.strings.added;
            setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; btn.disabled = false; }, 1600);
          }
          showNotify(item, cart);
        });
      }).catch(function () {
        if (btn) { btn.innerHTML = label; btn.disabled = false; }
      });
  }
  var notifyTimer;
  function showNotify(item, cart) {
    var el = $('#notify');
    if (!el || !AG.showNotify) return;
    item = item || {};
    var title = item.product_title || item.title || '';
    var img = item.image || (item.featured_image && item.featured_image.url) || '';
    var price = (typeof item.price === 'number') ? money(item.price) : '';
    el.innerHTML =
      '<div class="nh"><strong><i>✓</i>' + AG.strings.added + '</strong>' +
      '<button class="icon-btn" data-close-notify aria-label="close" style="width:34px;height:34px">✕</button></div>' +
      '<div class="np">' + (img ? '<div class="art cover"><img src="' + img + '" alt=""></div>' : '<span></span>') +
      '<div><h4>' + title + '</h4>' + (price ? '<span>1 × ' + price + '</span>' : '') + '</div></div>' +
      '<div class="sum">' + fill(AG.strings.inCart, { n: cart.item_count, total: money(cart.total_price) }) + '</div>' +
      '<div class="acts"><a class="btn" href="' + AG.cartUrl + '">' + AG.strings.view + ' (' + cart.item_count + ')</a>' +
      '<button class="btn btn-ghost" data-close-notify type="button">' + AG.strings.continue + '</button></div><div class="progress"></div>';
    el.classList.remove('is-open'); void el.offsetWidth; el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    clearTimeout(notifyTimer);
    var arm = function () { clearTimeout(notifyTimer); notifyTimer = setTimeout(hideNotify, 6000); };
    el.onmouseenter = function () { clearTimeout(notifyTimer); };
    el.onmouseleave = arm;
    arm();
  }
  function hideNotify() { var el = $('#notify'); if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); } }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') > -1) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      addToCart(id, form.querySelector('[data-add]'), false);
    }
  });
  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-buynow]');
    if (buy) { e.preventDefault(); addToCart(buy.dataset.buynow, buy, true); return; }
    var stickyAdd = e.target.closest('#stickyAtc [data-add]');
    if (stickyAdd) { e.preventDefault(); addToCart(stickyAdd.dataset.add, stickyAdd, false); }
  });

  /* ---------- Koszyk: ilość, usuwanie, zgody ---------- */
  document.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-cartqty] button');
    if (qb) {
      var box = qb.parentElement, inp = box.querySelector('input');
      var val = Math.max(1, (parseInt(inp.value, 10) || 1) + (qb.hasAttribute('data-inc') ? 1 : -1));
      changeLine(box.dataset.cartqty, val);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.closest('.line').dataset.line, 0); }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-cartqty] input');
    if (inp) changeLine(inp.parentElement.dataset.cartqty, Math.max(1, parseInt(inp.value, 10) || 1));
    var c = e.target.closest('[data-consent]');
    if (c) { c.closest('.check').classList.remove('err'); if (allConsents()) { var err = $('#consentErr'); if (err) err.textContent = ''; } }
  });
  function changeLine(line, qty) {
    fetch(AG.changeUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { window.location.reload(); });
  }
  function allConsents() { return $$('[data-consent]').every(function (i) { return i.checked; }); }
  var cartForm = $('#cartForm');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      var missing = $$('[data-consent]').filter(function (i) { return !i.checked; });
      if (missing.length) {
        e.preventDefault();
        missing.forEach(function (i) { var l = i.closest('.check'); l.classList.remove('err'); void l.offsetWidth; l.classList.add('err'); });
        var err = $('#consentErr'); if (err) err.textContent = AG.strings.consentError;
        missing[0].focus();
      }
    });
  }

  /* ---------- Sticky cart ---------- */
  var sticky = $('#stickyAtc'), buy = $('#product-form');
  if (sticky && buy && 'IntersectionObserver' in window) {
    var top = sticky.dataset.position === 'top';
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var gone = !e.isIntersecting && (e.boundingClientRect.top < 0 || (!top && e.boundingClientRect.top > window.innerHeight));
      sticky.classList.toggle('is-on', gone);
    }, { rootMargin: top ? '0px' : '0px 0px -20% 0px' }).observe(buy);
  }

  /* ---------- Nagłówek chowany przy przewijaniu ---------- */
  var lastY = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY, h = $('#header');
    if (!h) return;
    h.classList.toggle('is-hidden', y > lastY && y > 240);
    lastY = y;
  }, { passive: true });

  /* ---------- Menu: zwijanie do hamburgera ---------- */
  function fitNav() {
    var h = $('#header'), nav = $('.nav');
    if (!h || !nav) return;
    h.classList.remove('compact');
    if (window.innerWidth > 1024 && nav.scrollWidth > nav.clientWidth + 2) h.classList.add('compact');
  }
  window.addEventListener('resize', fitNav);
  fitNav();

  /* ---------- Ochrona treści ---------- */
  var P = AG.protect || {};
  if (P.select) document.body.classList.add('no-select');
  if (P.images) document.body.classList.add('no-drag');
  document.addEventListener('contextmenu', function (e) {
    if (P.rightClick || (P.images && e.target.tagName === 'IMG')) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) { if (P.images && e.target.tagName === 'IMG') e.preventDefault(); });
  ['copy', 'cut'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (P.select && !e.target.closest('input, textarea')) e.preventDefault();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (!P.shortcuts) return;
    var k = (e.key || '').toLowerCase();
    if (e.key === 'F12') e.preventDefault();
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && ['i', 'j', 'c'].indexOf(k) > -1) e.preventDefault();
    if ((e.ctrlKey || e.metaKey) && ['u', 's', 'p'].indexOf(k) > -1) e.preventDefault();
    if ((e.ctrlKey || e.metaKey) && k === 'a' && !e.target.closest('input, textarea')) e.preventDefault();
  });
})();
